import type {
  TenantPagamentoConfig, UpsertTenantPagamentoConfigCommand,
} from '@/domain/model/TenantPagamentoConfig';
import type { TenantPagamentoConfigGateway } from '@/application/port/out/TenantPagamentoConfigGateway';
import type {
  GetTenantPagamentoConfigUseCase, UpsertTenantPagamentoConfigUseCase,
} from '@/application/port/in/TenantPagamentoConfigUseCase';

export class GetTenantPagamentoConfig implements GetTenantPagamentoConfigUseCase {
  constructor(private readonly g: TenantPagamentoConfigGateway) {}
  execute(): Promise<TenantPagamentoConfig | null> { return this.g.get(); }
}
export class UpsertTenantPagamentoConfig implements UpsertTenantPagamentoConfigUseCase {
  constructor(private readonly g: TenantPagamentoConfigGateway) {}
  execute(c: UpsertTenantPagamentoConfigCommand): Promise<TenantPagamentoConfig> { return this.g.upsert(c); }
}
